import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import createMutationsSharer from 'vuex-shared-mutations'

// IE対策 TODO テスト
require('es6-promise/auto')

Vue.use(Vuex)

/**
 * データストアの保存先設定
 */
const vuexLocal = new VuexPersistence({
  key: process.env.STORAGE_KEY,
  storage: window.localStorage
})

/*
 * データストア（vuex）
 * アプリ全体の状態を保持するために使用する
 */
const initState = {
  token: '',
  app_id: '',
  downloaded: false // app_idがダウンロード済みかどうか
}

const replaceObj = function (obj) {
  return JSON.parse(JSON.stringify(obj))
}

const storeUtils = function (store) {
  store.resetState = function () {
    return replaceObj(initState)
  }
}

export default new Vuex.Store({
  plugins: [
    vuexLocal.plugin,
    storeUtils,
    createMutationsSharer({ predicate: ['setToken'] })
  ],
  state: replaceObj(initState),
  mutations: {
    setToken (state, token) {
      state.token = token
    },
    setAppId (state, app_id) {
      state.app_id = app_id
    },
    setDownloaded (state, downloaded) {
      state.downloaded = downloaded
    }
  },
  actions: {
    resetState (state) {
      this.resetState()
    },
    /**
     * this.$store.dispatch('saveTokenEtc')
     * @param context
     * @param token
     * @param app_id
     */
    saveTokenEtc (context, payload) {
      const token = payload.token
      const app_id = payload.app_id

      context.commit('setToken', token)
      context.commit('setAppId', app_id)
      context.commit('setDownloaded', false)

      // 最大5秒、tokenがストレージにセットされるまで待つ
      let startTime = +(new Date())
      let curTime = +(new Date()) - startTime
      let localToken = JSON.parse(localStorage.getItem(vuexLocal.key)).token
      while (curTime < 5000 && localToken !== token) {
        curTime = +(new Date()) - startTime
        localToken = JSON.parse(localStorage.getItem(vuexLocal.key)).token
      }
    },
    /**
     * ダウンロード済みにする
     * @param context
     */
    setDownloaded (context) {
      context.commit('setDownloaded', true)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js